module.exports = __webpack_public_path__ + "img/TUR-B-2-I.b1eb1394.png";